export default __webpack_public_path__ + "static/media/barak-11.72c67359.jpeg";